import { render, staticRenderFns } from "./checkFarChannel.vue?vue&type=template&id=38bfe64d&scoped=true&"
import script from "./checkFarChannel.vue?vue&type=script&lang=js&"
export * from "./checkFarChannel.vue?vue&type=script&lang=js&"
import style0 from "./checkFarChannel.vue?vue&type=style&index=0&id=38bfe64d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38bfe64d",
  null
  
)

export default component.exports